export default __webpack_public_path__ + "static/media/icon_direction_blue.bf672a5e.svg";